// Meta Pixel event helpers. Base code + PageView load once in public/index.html.
// Purchase is intentionally NOT fired here — Shopify is the only Purchase source.

// Meta catalog id format used by Shopify's Facebook & Instagram channel:
// shopify_{COUNTRY}_{productId}_{variantId}
const numericId = (gid) => (gid || "").split("/").pop();

export const metaContentId = (product) => {
  const pid = numericId(product?.shopifyProductId);
  const vid = numericId(product?.shopifyVariantId);
  if (!pid || !vid) return null;
  return `shopify_US_${pid}_${vid}`;
};

const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

const productParams = (product, quantity) => {
  const id = metaContentId(product);
  const price = product?.price ?? 29.99;
  return {
    content_ids: id ? [id] : undefined,
    content_type: "product",
    content_name: "CELUSTA Leave-In Conditioner",
    contents: id ? [{ id, quantity }] : undefined,
    value: Math.round(price * quantity * 100) / 100,
    currency: product?.currency || "USD",
  };
};

let viewContentFired = false;
export const trackViewContent = (product) => {
  if (viewContentFired || !metaContentId(product)) return;
  viewContentFired = true;
  fbq("track", "ViewContent", productParams(product, 1));
};

// Guard: a single click can never emit twice, but each separate successful
// add action (even rapid distinct clicks) generates its own event.
let lastAddToCart = { sig: null, t: 0 };
export const trackAddToCart = (product, quantity) => {
  try {
    const params = productParams(product, quantity);
    const sig = JSON.stringify(params);
    const now = Date.now();
    if (lastAddToCart.sig === sig && now - lastAddToCart.t < 50) return;
    lastAddToCart = { sig, t: now };
    fbq("track", "AddToCart", params);
  } catch (e) {
    // Tracking must never interrupt the cart action.
  }
};

let initiateCheckoutFired = false;
export const trackInitiateCheckout = (product, quantity) => {
  if (initiateCheckoutFired) return;
  initiateCheckoutFired = true;
  fbq("track", "InitiateCheckout", {
    ...productParams(product, quantity),
    num_items: quantity,
  });
};
